









import Vue from "vue";
import iwInputCheckbox from "@/encoding/components/buildingBlocks/InputCheckbox.vue";

export default Vue.extend({
    components: {
        iwInputCheckbox: iwInputCheckbox,
    },

    data: function () {
        return {
            pathInStore: "property.specificities.largeEnterprise.hasReceptionDesk",
        };
    },

    computed: {
        isDisplayed: function(): boolean {
            return ["OFFICE","INDUSTRY","COMMERCIAL"].indexOf(this.getPropertyType()) !== - 1;
        },

        hasReceptionDesk: {
            get: function(): boolean {
                return this.$store.getters["FormModule/getValue"](this.pathInStore);
            },

            set: function(value: boolean) {
                this.$store.dispatch("FormModule/addValue", {
                    path: this.pathInStore,
                    value: value
                });
            },
        },
    },
});
